export const YM_ID = 95153753;

export const MANAGER_URL = "https://t.me/VAPC_Manager_bot";
export const CHANNEL_URL = "https://t.me/vapcbuild";

// Раздаётся напрямую с прод-сервера nginx (/var/www/html/images/photos/).
// Относительный путь — фото грузятся с любого домена (va-pc.ru / vapc.store / хост mini-app),
// не завязаны на конкретный домен (vapc.store был недоступен → фото в «Инфо» пропадали).
const PHOTOS = "/images/photos";

export const FALLBACK_IMAGE = `${PHOTOS}/fallback.webp`;
export const HERO_IMAGE = `${PHOTOS}/main.webp`;

// Портфолио для Info → «Наши работы»
export const PORTFOLIO_PHOTOS = [
  { id: 1, src: `${PHOTOS}/work1.webp`, label: "Белый кастом с СЖО" },
  { id: 2, src: `${PHOTOS}/work2.webp`, label: "Чёрный mATX с RGB" },
  { id: 3, src: `${PHOTOS}/work3.webp`, label: "Белый с дисплеем СЖО" },
  { id: 4, src: `${PHOTOS}/work4.webp`, label: "Кастом с аэрографией" },
  { id: 5, src: `${PHOTOS}/work5.webp`, label: "Премиум-сборка" },
  { id: 6, src: `${PHOTOS}/work6.webp`, label: "Флагман с подсветкой" },
];

// Фотографии процесса сборки на детальной
export const BUILD_PROCESS_PHOTOS = [
  { id: 1, src: `${PHOTOS}/process1.webp`, label: "Установка процессора" },
  { id: 2, src: `${PHOTOS}/process2.webp`, label: "Новые комплектующие" },
  { id: 3, src: `${PHOTOS}/process3.webp`, label: "Подготовка корпуса" },
  { id: 4, src: `${PHOTOS}/process4.webp`, label: "Упаковка и отправка" },
];

export const CREDIT_RATE = 0.155;
